module.exports = __webpack_public_path__ + "img/attachment-1.1c0af388.svg";